module.exports = __webpack_public_path__ + "img/info-sea.6729892f.svg";